import { faPencil, faClose, faCheck, faE, faF, faI, faSitemap, faP, faO, faTrashAlt, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonProps} from "react-bootstrap";

interface ButtonBProps extends ButtonProps {
  onClick: () => void;
}
export const ButtonAlterar = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faPencil} />
    </Button>
  );
};

export const ButtonInativar: React.FC<ButtonBProps> = ({ onClick, ...props }) => {
  return (
    <Button 
      style={{ backgroundColor: '#dc3545', border: '1px solid #dc3545', color: 'white', cursor: 'pointer', textAlign: 'center' }}
      onClick={onClick} title="Inativar"
      {...props}
    >
      <FontAwesomeIcon icon={faClose} />
    </Button>
  );
};

export const ButtonAtivar: React.FC<ButtonBProps> = ({ onClick, ...props }) => {
  return (
    <Button style={{ backgroundColor: '#36D7B7', border: '1px solid #36D7B7', color: 'white',
    cursor: 'pointer', textAlign: 'center', }}
    onClick={onClick} title="Ativar"
    {...props}
    >
      <FontAwesomeIcon icon={faCheck} />
    </Button>
  );
};

export const ButtonEmpregador = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faE} />
    </Button>
  );
};

export const ButtonFinanciamento = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faF} />
    </Button>
  );
};

export const ButtonInfoGerais = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faI} />
    </Button>
  );
};

export const ButtonOrgao = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faSitemap} />
    </Button>
  );
};

export const ButtonAlterarOrgao:React.FC<ButtonBProps> = ({ onClick, ...props }) => {
  return (
    <Button id="App-button-cor-principal"
      onClick={onClick}
      {...props}
    >
      <FontAwesomeIcon icon={faPencil} />
    </Button>
  );
};

export const ButtonPromotora = () => {
  return (
    <Button id="App-button-cor-principal">
      <FontAwesomeIcon icon={faO} />
    </Button>
  );
};

export const ButtonAlterarMotivo:React.FC<ButtonBProps> = ({ onClick, ...props }) => {
  return (
    <Button id="App-button-cor-principal"
      onClick={onClick}
      {...props}
    >
      <FontAwesomeIcon icon={faPencil} />
    </Button>
  );
};

export const ButtonAcoesAlterar:React.FC<ButtonBProps> = ({ onClick, ...props }) => {
  return (
    <Button id="App-button-cor-principal"
      onClick={onClick}
      {...props}
    >
      <FontAwesomeIcon icon={faPencil} />
    </Button>
  );
};

export const ButtonExcluir = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-danger shadow-sm"
      style={{ borderRadius: '5px', padding: '5px 10px' }}
      onClick={onClick}
      title="Excluir Registro"
    >
      <FontAwesomeIcon icon={faTrashAlt} />
    </button>
  );
};